import React, { useState } from 'react'
import Web from './Web'
import Mobile from './Mobile'
import './header.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDharmachakra } from '@fortawesome/free-solid-svg-icons';

function Header() {
    const[isOpen, setIsOpen] = useState(false);

    const logo = "{ Prince }";

  return (
    <div className="header">
        <a href="#"> <div className="logo"> {logo} </div> </a> 
        <div className='Dharmachakra'>
        <FontAwesomeIcon icon={faDharmachakra} spin size="lg" style={{color: "#002d7a",}} />        </div>
        <div className="menu">
            <div className="web-menu">
                <Web/>
            </div>
            <div className="mobile-menu">
                <div onClick={()=>setIsOpen(!isOpen)}>
                <i class="fi fi-rr-apps menu-icon"></i>
                </div>
                {isOpen && <Mobile isOpen={isOpen} setIsOpen = {setIsOpen}/> }
            </div>
        </div>
    </div>
  )
}

export default Header